import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/home.svg',
})
export class AnalyticsComponent {}
